<template>
	<div class="personHome">
		<!-- 左侧产品列表 -->
		<div class="psLeftContent">
			<!-- 下载记录 -->
			<div class="item w100">
				<div class="text bd10 p3">
					<div class="sTitle d-flex a-center j-sb">
						 <h3 class="font20">{{$t('adminMenu.download')}}</h3>
					</div>
					<div class="table font-light line-mn">
						<dl>
							<dt class="d-flex">
								<span>{{$t('admin.downloadContent')}}</span>
								<span>{{$t('admin.contentType')}}</span>
								<span>{{$t('admin.downloadDate')}}</span>
								<span class="span_min">{{$t('admin.downloadBtn')}}</span>
								<!-- <span class="span_min">{{$t('admin.process')}}</span> -->
							</dt>
							<dd class="d-flex"  v-for="(item, index) in downloadVoList" :key="item.id">
								<span class="nowrap2"><a @click="downloadFile(index,item.id)" class="link" :title="item.title">{{item.title}}</a></span>
								<span>{{item.contentTypeDictText}}</span>
								<span>{{item.createTime}}</span>
								<span class="span_min d-flex j-center a-center">
									<vdownload :id="item.id" path="" api="member/getDownload"></vdownload>
								</span>
								<!-- <span class="span_min">
									<el-progress :percentage="item.dp" :show-text="true" :stroke-width="4"></el-progress>
								</span> -->
							</dd>
						</dl>
					</div>
				</div>
				<!-- 分页 -->
				<div class="pagination">
					 <el-pagination
						   @current-change="handleCurrentChange"
						   :page-size="10"
						   layout="prev, pager, next"
						   :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
  name: 'DownloadHistory',
  components: {
    
  },
  data() {
    return {
		// 下载记录
		downloadVoList: [],
		downloadQuee:[],
		// 分页
		pagination: {
			pageNo: 1,
			pageSize: 10
		},
		// 数量
		total: 0
		
	}
  },
  
  created() {
  	  // 获取下载记录
  	  this.getDownloadVoList();
  },
  
  methods: {
  	  // 获取下载记录
  	  getDownloadVoList() {
  		  this.$axios.post('member/downloadPage', this.pagination)
  		  .then(res => {
			  res.data.list.forEach(i=>{i.dp=0});
  			  this.downloadVoList = res.data.list;
  			  this.total = res.data.total;
  		  })
  		  .catch(err => {})
  	  },
  	  
  	  // 点击翻页
  	  handleCurrentChange(current) {
  		  this.pagination.pageNo = current;
  		  // 更新
  		  this.getDownloadVoList();
  	  },
	downloadFile(index,id){
		var that=this;
		if(that.downloadVoList[index].dp!=0){return;}
		that.$daxios
        .get(`member/getDownload?id=${id}`,{
          responseType: 'blob',
		  onDownloadProgress:e=>{
			that.downloadVoList[index].dp=Math.floor(e.progress*100);
		  }
        })
        .then((res) => {
		  if(res.data&&res.data.size==0){
			that.downloadVoList[index].dp=0;
			that.$message({
				message:"下载失败",
				type: 'error'
			});
			return;
		  };
          const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
          const link = document.createElement('a');
          let fileName = res.headers['content-file-name'];
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => {
			that.downloadVoList[index].dp=0;
        });
	},
		downloadFileUrl(index,fileurl,filename){
			var that=this;
			if(!fileurl){return;}
			var durl=fileurl.split('admin-api')[1];
			var fname=durl.split('.')[1]==filename.split('.')[1]?filename:(filename+durl.split('.')[1]);
			if(that.downloadVoList[index].dp==0){
				that.downloadVoList[index].dp=1;
				that.$uaxios.get(durl,{
					responseType: 'arraybuffer',
					onDownloadProgress:e=>{
						that.downloadVoList[index].dp=Math.floor(e.progress*100);
					},
				}).then(res=>{
					const url = window.URL.createObjectURL(new Blob([res.data]),{ type: 'application/octet-stream' });
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', fname);
					document.body.appendChild(link);
					link.click();
					link.remove();
				}).catch(err => {
					that.downloadVoList[index].dp=0;
				})
			}
		}
  }
}
</script>

<style lang="less" scoped>

 	.personHome{
		
		.psLeftContent{
			width: 100%;
			.toPage{
				margin-left: .15rem;
				input{
					width: .4rem;
					height: .4rem;
					border-radius: 5px;
					background: #fff;
					text-align: center;
					margin: 0 5px;
					padding: 0 5px;
				}
			}
			.item{
				width: 50%;
				margin-bottom: .2rem;
				&.w100{
					width: 100%;
					dd:hover,dd:hover a{
						color: #2657db;
					}
				}
			}
			.table{
				dl{
					dt,dd{
						padding: .22rem 0;
					}
					dt{
						background: #f2f5fa;
						border-radius: 5px;
						span:nth-of-type(1) {
							padding-left: .15rem;
						}
					}
					dd{
						&:not(:last-child) {
							border-bottom: solid 1px #eee;
						}
						span:nth-of-type(1) {
							position: relative;
							padding-left: .2rem;
							&:after{
								content: "";
								position: absolute;
								left: 0;
								top: .1rem;
								width: .04rem;
								height: .04rem;
								background: #2657db;
							}
						}
					}
					span{
						a{
							cursor: pointer;
						}
						.d{
							width: .15rem;
							height: .17rem;
							background: url(@/assets/Icons/downloadGray.png) no-repeat center/100% 100%; 
							&:hover{
								background-image: url(@/assets/Icons/downloadBlue.png);
							}
						}
						width: 13%;
						&:nth-of-type(1) {
							width: calc(87% - 4rem);
						}
						&.span_min{
							width: 2rem;
							text-align: center;
						}
					}
				}
			}
		}
		
		@media (max-width: 640px) {
			padding: .2rem;
			.psLeftContent{
				.table{
					dl{
						
					}
				}
			}
		}
	}
</style>
